import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/translations/${url.id}`, config),
    fetch: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/translations/${url.project}`, config),
    fetchCompare: (config: AxiosRequestConfig) =>
        api.get(`/translations/compare`, config),
    bulkAdd: (data: object, config: AxiosRequestConfig) =>
        api.put(`/translations/push`, data, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/translations/${url.project}/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.post(`/translations/${url.project}`, data, config),
    google: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.post(`/translations/${url.project}/google`, data, config),
    toService: (config: AxiosRequestConfig, url: RequestUrlId) => {
        return api.get(`/translations/sync/${url.project}`, config);
    },

    improveText: (data: object, config: AxiosRequestConfig) =>
        api.get("/translations/improve/text", config),
    translate: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/translations/${url.project}/${url.id}/translate`, config),
    translateBulk: (
        data: object,
        config: AxiosRequestConfig,
        url: RequestUrlId,
    ) => api.put(`/translations/${url.project}/translate/bulk`, data, config),

    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/translations/${url.project}/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/translations/${url.project}/${url.id}`, data, config),
    bulkImport: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.post(`/translations/${url.project}/bulk`, data, config),
    contextBulk: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/translations/${url.project}/context/bulk`, data, config),
};

export default requests;
